import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

export const getProjectSubprojectName = (
  projectName: string,
  subprojectName: string | undefined,
  hasFeature = true
) => {
  let name = ''

  if (projectName) {
    name = projectName
  }
  if (hasFeature && subprojectName) {
    name += ' · ' + subprojectName
  }

  return name
}

export const getFixedTimeBudgetProgressBarLabel = (
  imputedMinutes: string,
  budgetAllocation: string
) => {
  return imputedMinutes + ' / ' + budgetAllocation
}

export const MoneyWithStringCurrency = (amount: number, currency: string, locale: string) => {
  if (isCurrency(currency)) {
    return MoneyWithCurrency({
      amount: amount,
      currency: currency,
      locale: locale,
      optionalDecimals: true,
    })
  } else {
    return '-'
  }
}

export const getFixedCostPlanningProgressBarLabel = (
  cost: number,
  budgetAllocationCents: number,
  currency: string,
  locale: string
) => {
  return `${MoneyWithStringCurrency(cost, currency, locale)} / ${MoneyWithStringCurrency(
    budgetAllocationCents,
    currency,
    locale
  )}`
}
